
<template>
  <div class="card">
    <div class="top">
      <el-input v-model="form.name" placeholder="输入房號搜寻"  suffix-icon="el-icon-search" @keyup.enter.native="getRoom"></el-input>
      <el-button @click="addRoom">新增房間</el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%;margin-top: 20px"
      :header-cell-style="{'background':'#C6C6C6','color':'#ffffff'}">
      <el-table-column
        prop="date"
        label="編號"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="房號"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        label="備註">
      </el-table-column>
      <el-table-column
        label="更多操作"
        width="100">
        <template v-slot="{row}">
          <el-button class="checkbtn" @click="addRoom(1,row)" type="text" size="small">查看 / 编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="total">
    </el-pagination>
    <roomDig ref="roomDig" @done="getRoom"></roomDig>
  </div>
</template>
<script>


import { roomList } from "@/api";

export default {
  name: "room.vue",
  components: {
    roomDig: () => import('@/views/System/roomDig.vue')
  },
  data(){
    return{
  tableData: [],
      form:{
        name:'',
        page:1,
        limit:10
      },
      total: 0
}
},
  mounted() {
    this.getRoom()
  },
  methods:{
  addRoom(i,row){
    if(i == 1){
      this.$refs.roomDig.init(i, JSON.parse(JSON.stringify(row)))
    }else{
      this.$refs.roomDig.init()
    }

  },

  getRoom(){
    roomList(this.form).then(res =>{
        this.tableData = res.data.list
        this.total = res.data.total
    })
  },
  handleCurrentChange(val) {
    this.form.page = val
    this.getRoom()
  }
}
};
</script>



<style scoped lang="scss">
.card{
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #FFFFFF;
  margin-top: 20px;
  .top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    .el-input{
      width: 400px;
    }
    ::v-deep .el-input__inner{
      border: none;
      background: #F8F8F8;
    }
    .el-button{
      color: #FFFFFF;
      border: none;
      background: #DBBD80;
    }
  }
}
.el-button--text {
  color: #DBBD80;
  padding: 5px 10px;
  border: 1px solid #DBBD80;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #DBBD80;
  color: #FFFFFF !important;
}
</style>
